import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e1546544")

_pushScopeId("data-v-e1546544")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("にログイン")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("ログイン")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("アカウントを新規に作成する")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("パスワードを忘れた場合")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_logo = _resolveComponent("logo")
  const _component_icon_edit_box = _resolveComponent("icon-edit-box")
  const _component_normal_button = _resolveComponent("normal-button")
  const _component_link_text = _resolveComponent("link-text")
  const _component_vue_login_form = _resolveComponent("vue-login-form")
  const _component_vue_login_frame = _resolveComponent("vue-login-frame")
  const _directive_focus = _resolveDirective("focus")
  const _directive_enter = _resolveDirective("enter")

  return (_openBlock(), _createBlock(_component_vue_login_frame, null, {
    default: _withId(() => [
      _createVNode(_component_vue_login_form, null, {
        default: _withId(() => [
          _createVNode("h1", null, [
            _createVNode(_component_logo),
            _hoisted_1
          ]),
          _withDirectives(_createVNode(_component_icon_edit_box, {
            class: "login-edit-box",
            icon: "envelope",
            title: "ログイン名",
            placeholder: "Eメールアドレス",
            modelValue: _ctx.userId,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.userId = $event)),
            validation: _ctx.submitted ? _ctx.userIdError : undefined,
            ref: "userIdRef"
          }, null, 8, ["modelValue", "validation"]), [
            [_directive_focus, 'userIdRef'],
            [_directive_enter, {focus:'passwordRef'}]
          ]),
          _withDirectives(_createVNode(_component_icon_edit_box, {
            class: "login-edit-box",
            icon: "lock",
            title: "パスワード",
            placeholder: "パスワード",
            inputType: "password",
            modelValue: _ctx.password,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.password = $event)),
            validation: _ctx.submitted ? _ctx.passwordError : undefined,
            ref: "passwordRef"
          }, null, 8, ["modelValue", "validation"]), [
            [_directive_enter, {click:'submitRef'}]
          ]),
          _createVNode(_component_normal_button, {
            class: "submit-button",
            state: "normal",
            ref: "submitRef",
            onClick: _ctx.onLogin
          }, {
            default: _withId(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_link_text, { link: "/signup" }, {
            default: _withId(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_link_text, { link: "/reminder" }, {
            default: _withId(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})